import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './OrderManage.scss';
import { getAllOrders, createNewOrderService, deleteOrderService, editOrderService } from '../../../services/orderService';
import ModalOrder from './ModalOrder';
import ModalEditOrder from './ModalEditOrder';
import { emitter } from '../../../utils/emitter' // ham tao su kien
class OrderManage extends Component {

    constructor(props) { // Ham khoi tao
        super(props);
        this.state = {
            arrOrders: [],
            isOpenModal: false,
            isOpenModalEditOrder: false,
            orderEdit: [],
        }
    }

    async componentDidMount() {  // set bien, goi api
        await this.getAllOrderFromReact()

    }
    getAllOrderFromReact = async () => {
        let response = await getAllOrders("All");
        if (response && response.errCode == 0) {
            this.setState({
                arrOrders: response.orders
            })
            console.log(this.state.arrOrders);
        }
    }
    createNewOrder = async (data) => {

        try {
            let response = await createNewOrderService(data);
            if (response && response.errCode !== 0) {
                await this.getAllOrderFromReact()
                this.setState({
                    isOpenModal: false,
                })
                emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });

            } else {
                console.log("order didn't create");
            }

        } catch (error) {

        }
    }
    editOrder = async (data) => {
        try {
            let response = await editOrderService(data);
            if (response && response.errCode !== 0) {
                await this.getAllOrderFromReact()
                this.setState({
                    isOpenModalEditOrder: false,
                })
                // emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });
                console.log('trang thai tra ve ham edit: ', response)
            } else {
                console.log("order didn't create");
            }

        } catch (error) {

        }
    }
    handleAddNewOrder = () => {
        this.setState({
            isOpenModal: true
        })
        // alert("from handleAddNewOrder");
    }
    handleDeleteOrder = async (data) => {

        let response = await deleteOrderService(data);
        if (response && response.errCode !== 0) {
            await this.getAllOrderFromReact()
            this.setState({
                isOpenModal: false,
            })

        } else {
            console.log("order didn't create");
        }

    }
    handleEditOrder = async (data) => {

        this.setState({
            isOpenModalEditOrder: true,
            orderEdit: data
        })
    }
    toogleOrderModal = () => {
        this.setState({
            isOpenModal: !this.state.isOpenModal
        })
    }
    toogleOrderEditModal = () => {
        this.setState({
            isOpenModalEditOrder: !this.state.isOpenModalEditOrder
        })
    }
    render() {
        console.log('check render : ', this.state.isOpenModal);
        let arrOrders = this.state.arrOrders;
        // console.log('check render : ', arrOrders);
        // props - properties, nested, lay data tu Thang cha chuyen cho thang con, thang cha lay du lieu goc tu API
        return (
            <div className="orders-container">
                <ModalOrder
                    isOpen={this.state.isOpenModal}
                    tooglefromParent={this.toogleOrderModal}
                    createNewOrder={this.createNewOrder}
                />
                {this.state.isOpenModalEditOrder &&
                    <ModalEditOrder
                        isOpen={this.state.isOpenModalEditOrder}
                        tooglefromParent={this.toogleOrderEditModal}
                        currentOrder={this.state.orderEdit}
                        editCurrentOrder={this.editOrder}
                    // createNewOrder={this.createNewOrder}
                    />
                }

                <div className='title text-center'> Manage Order by Admin</div>
                <div className="mx-1">
                    <button class="btn btn-primary px-3"
                        onClick={() => this.handleAddNewOrder()}
                    ><i class="fas fa-plus"></i>Add new Order</button>

                </div>
                <div className='order-table mt-3 mx-1'>
                    <table id="customers">
                        <tr>
                            <th>email</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Actions</th>
                        </tr>

                        {/* su dung vong lap MAP function javascript */}
                        {arrOrders && arrOrders.map((item, index) => {
                            // console.log('check map', item, index);
                            return (
                                <tr>

                                    <td>{item.email}</td>
                                    <td>{item.fullname}</td>
                                    <td>{item.address}</td>
                                    <td>
                                        <button className='btn-edit'
                                            onClick={() => this.handleEditOrder(item)}
                                        ><i class="fas fa-pencil-alt"></i></button>
                                        <button className='btn-delete'
                                            onClick={() => this.handleDeleteOrder(item)}
                                        > <i className="fas fa-trash-alt"></i></button>

                                    </td>
                                </tr>

                            )
                        })
                        }



                    </table>
                </div>
            </div >
        );
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderManage);
